import { IMAGE_RATIO, ImageRatioValues } from 'defs/assets';
import { ImageDtoType } from 'types/services/magnolia/dtos/ImageDto';
import { AssetsStateType, initialState, RootStateType } from './assets';

export const getState = (state: RootStateType): AssetsStateType => {
	return state.assets || initialState;
};

export const getAsset = (
	state: RootStateType,
	path: string,
	ratio: ImageRatioValues = IMAGE_RATIO.R1_1 as any
): ImageDtoType | undefined => {
	const assetRenditions = state.assets.container[path];
	return assetRenditions ? assetRenditions[ratio] : undefined;
};
